export default __webpack_public_path__ + "static/media/Pro-8b.a4c55f8e.png";